// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import {getAuth, GoogleAuthProvider} from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBWmJSav7RDxJsqlmAFIwiKRXiQBzkuoJI", //
  authDomain: "middgpt.firebaseapp.com", //
  databaseURL: "https://middgpt-default-rtdb.firebaseio.com",
  projectId: "middgpt", //
  storageBucket: "middgpt.firebasestorage.app", //
  messagingSenderId: "253253074084", //
  appId: "1:253253074084:web:7979b3ea1776bd32bdba31", //
  measurementId: "G-Q0S6MR3H10" //
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app)
const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();

// Commented out emulator connections for now - using production
// if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
//   const { connectAuthEmulator } = require('firebase/auth');
//   const { connectFirestoreEmulator } = require('firebase/firestore');
//   const { connectFunctionsEmulator } = require('firebase/functions');
//   const { connectStorageEmulator } = require('firebase/storage');
//   
//   try {
//     connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
//     connectFirestoreEmulator(db, 'localhost', 8080);
//     connectFunctionsEmulator(functions, 'localhost', 5001);
//     connectStorageEmulator(storage, 'localhost', 9199);
//     console.log('Connected to Firebase emulators');
//   } catch (error) {
//     console.log('Firebase emulators connection:', error.message);
//   }
// }

// Add calendar scope
googleProvider.addScope('https://www.googleapis.com/auth/calendar');

export { auth, db, storage, functions };
